import { gql } from '@apollo/client'
import { useMutation } from '@apollo/client/react'
import { Field, type ISchema, useForm } from '@homemaster/jslib'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import { AddSiteDocument, type SiteInput, SiteRole } from '../../gql/graphql'
import { useRole } from '../../hooks'

gql`
  mutation AddSite($siteInput: SiteInput!) {
    addSite(siteInput: $siteInput) {
      id
      name
      location
    }
  }
`

const schema: ISchema = {
  rules: {
    name: 'required',
    location: 'required|min:5',
    phone: 'required',
  },
  messages: {
    'required.name': '必须输入场馆名称',
    'required.location': '必须输入场馆地址',
    'min.location': '场馆地址长度必须至少为5个字符',
    'required.phone': '必须输入联系电话',
  },
}

interface CreateSiteDialogProps {
  open: boolean
  onClose: () => void
}

export default function CreateSiteDialog({ open, onClose }: CreateSiteDialogProps) {
  const form = useForm<SiteInput>({ name: '', location: '', phone: '' }, schema)
  const { addSite: addSiteToContext } = useRole()

  const [addSite, { loading }] = useMutation(AddSiteDocument, {
    onCompleted: (data) => {
      addSiteToContext({
        id: data.addSite.id,
        name: data.addSite.name,
        roles: [SiteRole.SuperAdmin],
      })
      form.reset()
      onClose()
    },
  })

  const handleSubmit = () => {
    if (form.validate(false) === undefined) {
      addSite({ variables: { siteInput: form.values } })
    }
  }

  const handleClose = () => {
    form.reset()
    onClose()
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>创建场馆</DialogTitle>
      <DialogContent>
        <Field
          autoFocus
          label="场馆名称"
          fullWidth
          form={form}
          name="name"
          variant="outlined"
        />
        <Field
          label="场馆地址"
          fullWidth
          variant="outlined"
          form={form}
          name="location"
        />
        <Field
          label="联系电话"
          fullWidth
          variant="outlined"
          form={form}
          name="phone"
          type="tel"
          slotProps={{ htmlInput: { pattern: '[0-9\\-]*' } }}
          onKeyDown={(e: React.KeyboardEvent) => {
            if (e.key.length === 1 && !/[\d-]/.test(e.key)) e.preventDefault()
          }}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} disabled={loading}>
          取消
        </Button>
        <Button onClick={handleSubmit} variant="contained" disabled={loading}>
          创建
        </Button>
      </DialogActions>
    </Dialog>
  )
}
